export default __webpack_public_path__ + "static/vision02-8b911c687384118f6a17cb58109ada4d.jpg";